import React, { Component } from 'react';
import classNames from 'classnames';
import ReactResizeDetector from 'react-resize-detector';
import './index.scss';

const RIGHT_SCROLL = 100;
const LEFT_SCROLL = -RIGHT_SCROLL;
const DEFAULT_DIRECTION_TIMES = 65;

// Change speed when smaller window width so all terms will be displayed
const renderDirectioTimes = (width) => {
    if (width < 800) {
        return 20;
    }
    else if (width < 1000) {
        return 35;
    }
    else if (width < 1200) {
        return 50;
    }
    return DEFAULT_DIRECTION_TIMES;
};

const applyScroll = (ref, delta, width) => {
    const direction = delta / Math.abs(delta);
    const directionTimes = renderDirectioTimes(width);
    let starttime = 0;

    function moveit(timestamp, duration = 250) {
        const currentTimestamp = timestamp || new Date().getTime();
        const runtime = currentTimestamp - starttime;

        if (runtime > duration) {
            return;
        }

        requestAnimationFrame((timestamp) => {
            ref.scrollLeft += direction * directionTimes;
            moveit(timestamp);
        });
    }

    requestAnimationFrame((timestamp) => {
        starttime = timestamp || new Date().getTime(); // if browser doesn't support requestAnimationFrame, generate our own timestamp using Date
        ref.scrollLeft += direction * directionTimes;
        moveit(starttime);
    });
};

class DynamicCarousel extends Component {

    constructor(props) {
        super(props);

        this.nav;

        this.state = {
            canScrollLeft: false,
            canScrollRight: false
        };

        this.scroll = this.scroll.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.shouldUpdateCanScrollLeft = this.shouldUpdateCanScrollLeft.bind(this);
        this.shouldUpdateCanScrollRight = this.shouldUpdateCanScrollRight.bind(this);
    }

    componentDidMount() {
        if (!this.nav) {
            return;
        }

        this.nav.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);

        this.handleScroll();
    }

    componentWillUnmount() {
        this.nav && this.nav.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
    }

    shouldUpdateCanScrollLeft() {
        const scrollLeft = this.nav.scrollLeft,
            canScrollLeft = scrollLeft > 0;

        return this.state.canScrollLeft !== canScrollLeft;
    }

    shouldUpdateCanScrollRight() {
        const scrollLeft = this.nav.scrollLeft,
            scrollView = this.nav.scrollWidth - this.nav.clientWidth,
            canScrollRight = scrollLeft < scrollView;

        return this.state.canScrollRight !== canScrollRight;
    }

    handleScroll() {
        const scrollLeft = this.nav.scrollLeft,
            scrollView = this.nav.scrollWidth - this.nav.clientWidth,
            canScrollLeft = scrollLeft > 0,
            canScrollRight = scrollLeft < scrollView;

        if (this.shouldUpdateCanScrollLeft() || this.shouldUpdateCanScrollRight()) {
            this.setState({
                canScrollLeft,
                canScrollRight
            });
        }
    }

    scroll(value, width) {
        applyScroll(this.nav, value, width);
    }

    render() {
        const { canScrollLeft, canScrollRight } = this.state;
        const { renderTerm, terms = [] } = this.props;

        if (terms.length <= 0) {
            return null;
        }

        return (
            <ReactResizeDetector handleWidth
                refreshMode="throttle"
                refreshRate={400}
                render={({ width }) => (
                    <div className={classNames('dynamic-carousel', { 'scroll-left': canScrollLeft, 'scroll-right': canScrollRight })} >
                        <div className={classNames('button-wrap left', { 'visible': canScrollLeft })}>
                            <button onClick={() => this.scroll(LEFT_SCROLL, width)}/>
                        </div>
                        <div className={classNames('button-wrap right', { 'visible': canScrollRight })}>
                            <button onClick={() => this.scroll(RIGHT_SCROLL, width)}/>
                        </div>
                        <nav style={{ width }} ref={(_ref) => this.nav = _ref}>
                            {
                                terms.map((term) => renderTerm(term))
                            }
                        </nav>
                    </div>
                )
                }/>
        );
    }
}

export default DynamicCarousel;
